module.exports = __webpack_public_path__ + "static/media/Grupo1.2ecaf473.svg";